const initState = {
    originalClaim:undefined,
    PatientInfo: [],
    FacilityInfo: [],
    ClaimInfo:[],
    ReplacementInfo:[],
    buId: undefined,

};

export const SET_PATIENT_INFO = 'SET_PATIENT_INFO';
export const SET_FACILITY_INFO = 'SET_FACILITY_INFO';
export const SET_CLAIM_INFO = 'SET_CLAIM_INFO';
export const SET_REPLACEMENT_INFO = 'SET_REPLACEMENT_INFO';
export const SET_ORIGNALCLAIM_INFO = 'SET_ORIGNALCLAIM_INFO';


export const setPatientInfo = (data) => ({ type: SET_PATIENT_INFO, payload: data });
export const setFacilityInfo = (data) => ({ type: SET_FACILITY_INFO, payload: data });
export const setClaimInfo = (data) => ({ type: SET_CLAIM_INFO, payload: data });
export const setReplacementInfo = (data) => ({ type: SET_REPLACEMENT_INFO, payload: data });
export const setNewClaim = (data) => ({ type: SET_ORIGNALCLAIM_INFO, payload: data });


export default (state = initState, action) => {
    switch (action.type) {
        case SET_PATIENT_INFO:
            return { ...state, PatientInfo: action.payload };
        case SET_FACILITY_INFO:
            return { ...state, FacilityInfo: action.payload };
        case SET_CLAIM_INFO:
            return { ...state, ClaimInfo: action.payload };
        case SET_REPLACEMENT_INFO:
            return { ...state, ReplacementInfo: action.payload };
        case SET_ORIGNALCLAIM_INFO:
            return { ...state, originalClaim: action.payload };
        default:
            return state
    }
}
